import { Plus } from 'lucide-react';

interface AddPhotoPlaceholderProps {
    onAddPhotoClick: () => void;
}

export function AddPhotoPlaceholder({ onAddPhotoClick }: AddPhotoPlaceholderProps) {
    return (
        <button
            onClick={onAddPhotoClick}
            className="group relative bg-card/30 hover:bg-card/50 rounded-[24px] border-2 border-dashed border-border hover:border-primary/50 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1 w-full"
            style={{ aspectRatio: '16/10' }}
        >
            <div className="w-16 h-16 rounded-full bg-background shadow-md flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mb-4 border border-border/50">
                <Plus className="w-8 h-8 text-muted-foreground group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
            </div>

            <div className="text-center">
                <h3 className="text-[18px] font-semibold text-muted-foreground group-hover:text-foreground transition-colors duration-300">
                    Dodaj zdjęcie
                </h3>
                <p className="text-[13px] text-muted-foreground/70 mt-1">
                    Kliknij aby dodać nowy render
                </p>
            </div>
        </button>
    );
}
